export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7491.385c40ec.jpg";